"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import {
  getStoredFirstTouchUtms,
  readUtmsFromUrl,
  storeUtmsIfFirstTouch,
} from "@/utils/utm";

export function UtmTracker() {
  useEffect(() => {
    const fromUrl = readUtmsFromUrl();
    storeUtmsIfFirstTouch(fromUrl);

    const firstTouch = getStoredFirstTouchUtms();
    const merged = { ...firstTouch, ...fromUrl };

    if (Object.keys(merged).length === 0) return;

    posthog.register(merged);
    posthog.setPersonProperties(fromUrl, firstTouch);
  }, []);
  return null;
}
